<template>
  <div class="user-list">
    <vuetable ref="vuetable" :fields="fields" :api-mode="false" :data="userList" :first-page="0">
      <div slot="avatar" slot-scope="props">
        <ui-avatar :url="props.rowData.avatar" :username="props.rowData.username"></ui-avatar>
      </div>
      <div slot="role" slot-scope="props">
        <span>{{props.rowData.role}}</span>
        <span v-if="props.rowData.role == 'vip'"> ( {{formatDate(props.rowData.vipInfo.expiredTime)}})</span>
      </div>
      <div slot="action" slot-scope="props">
        <span @click="currentId = props.rowData.id;vipModal = true" v-if="props.rowData.role == 'user'">set vip</span>
      </div>
    </vuetable>
    <ui-modal v-model="vipModal" custom-class="set-vip-modal">
      <span slot="header">选择Vip有效时间</span>
      <date-picker :disabled="neverExpired" v-model="expiredDate"></date-picker>
      <ui-checkbox v-model="neverExpired">永不过期</ui-checkbox>
      <span slot="footer">
        <ui-button @click="vipModal = false;currentId=''" type="border">取消</ui-button>
        <ui-button @click="setVip">确定</ui-button>
      </span>
    </ui-modal>
  </div>
</template>
<script>
import adminApi from '../../api/admin.js'
import Vuetable from 'vuetable-2'
import dayjs from 'dayjs'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'userList',
  data() {
    return {
      userList: [],
      vipModal: false,
      currentId: '',
      expiredDate: dayjs().add(1, 'year'),
      neverExpired: false,
      fields: [{
          name: 'avatar',
          title: 'User'

        },
        { name: 'email' },
        {
          name: 'created',
          formatter: (value) => {
            return this.formatDate(value)
          }
        },
        {
          name: 'last_login',
          formatter: (value) => {
            return this.formatDate(value)
          }
        },
        { name: 'lang', title: 'language' },
        { name: 'role' },
        { title: 'Action', name: 'action' }
      ]
    }
  },
  components: {
    Vuetable,
    DatePicker
  },
  mounted() {
    adminApi.userList().then(res => {
      this.userList = res.data.userList
    }).catch(e => {
      console.log(e)
    })
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
    setVip() {

      adminApi.setVip({
        expiredDate: this.neverExpired ? new Date('2099-1-1') : this.expiredDate,
        userId: this.currentId
      }).then(res => {
        this.vipModal = false
        this.currentId = ''
        console.log(res)
      }).catch(err => {
        this.vipModal = false
        this.currentId = ''
        this.$UiToast.error('set vip failed')
      })
    }
  }
}

</script>
<style lang="scss">
.set-vip-modal {
  .ui-modal-body {
    height: 400px;
  }
}


</style>
